import React from 'react';
import { ScaleIcon } from '@heroicons/react/24/outline';
import LegalDocument from '../components/LegalDocument';
import { termsOfServiceContent } from '../content/termsOfService';

const TermsOfServicePage = () => {
  return <LegalDocument content={termsOfServiceContent} icon={ScaleIcon} />;
};

export default TermsOfServicePage;
